import { useEffect } from 'react';
import type { DiscordConnectionStatus } from '@playerbase/types';

import { requestDiscordRecheck } from './discord-data.js';

// ---------------------------------------------------------------------------
// Fire request_discord_connection_recheck whenever a non-disconnected row
// is shown. Pending rows are included on purpose: they cover the install
// race where GuildCreate landed before the OAuth callback inserted the
// row, so the bot now needs to look at its already-cached guild to
// confirm.
//
// Deps are id + status only (not the whole row): the bot rewrites
// last_health_check_at on every recheck, and depending on the full row
// would loop us into an infinite recheck/Realtime/refetch cycle.
// ---------------------------------------------------------------------------

export function useDiscordRecheckOnMount(
  connectionId: string | null,
  status: DiscordConnectionStatus | null,
): void {
  useEffect(() => {
    if (connectionId === null) return;
    if (status === 'disconnected') return;
    void requestDiscordRecheck(connectionId);
  }, [connectionId, status]);
}
